import React, {memo} from 'react'
import {NavigationList} from './styles'
import {NavigationComponents} from '../types'
import {NavigationItemEntry} from '../../../../../features/navigation/types'

type ContainerProps = {
  items: NavigationItemEntry[]
  level: number
  components: NavigationComponents
}

const Container: React.FC<ContainerProps> = ({items, components, level}) => {
  if (!items || items.length === 0) {
    return null
  }
  return (
    <NavigationList level={level} itemCount={items.length}>
      {items.map(item => (
        <components.navigationItem
          key={item.route}
          sectionName={item.sectionName}
          label={item.label}
          translationKey={item.translationKey}
          route={item.route}
          actions={item.actions}
          icon={item.icon}
          skipIfNoSubNavigation={item.skipIfNoSubNavigation}
          components={components}
          level={level}
          permissions={item.permissions}
          linkProps={item.linkProps}
        />
      ))}
    </NavigationList>
  )
}

export default memo(Container)
